import { Layout } from '../../components/Layout/Layout';
import { reset } from '../../containers/ChatsList/chatListSlice/actionCreators';
import { ChatsList } from '../../containers/ChatsList/ChatsList';
import { useAppDispatch } from '../../hooks';
import { useTenantNameSubtitle } from '../../utils/customHooks/useTenantNameSubtitle';

export const ChatPage = () => {
  const dispatch = useAppDispatch();
  const tenantNameSubtitle = useTenantNameSubtitle();
  const handleGoBack = () => {
    dispatch(reset());
  };
  return (
    <Layout
      isMessageLayout
      message={'coalert_messages_title'}
      to="/dashboard"
      showBottomTabs
      subMessageText={tenantNameSubtitle}
      subMessageType="accent"
      backBtnCallBack={handleGoBack}
    >
      <ChatsList />
    </Layout>
  );
};
